import { useState } from "react";
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { Href, Inbox, More } from "../../../Constant";
import Reademail from "./Reademail";

const EmailComposeContainData = () => {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const toggle = () => setDropDownOpen(!dropDownOpen);

  return (
    <Col xl="4" md="12" className="box-md-3 pr-0">
      <div className="pe-0"></div>
      <div className="email-top">
        <Row>
          <Col className="pt-2 pb-2">
            <H3>{Inbox}</H3>
          </Col>
          <Col className="text-end">
            <Dropdown isOpen={dropDownOpen} toggle={toggle}>
              <DropdownToggle color="default" className="btn dropdown-toggle">
                {More}
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem href={Href}>Action</DropdownItem>
                <DropdownItem href={Href}>Another action</DropdownItem>
                <DropdownItem href={Href}>Something else here</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
      </div>
      <Nav>
        <Reademail />
      </Nav>
    </Col>
  );
};

export default EmailComposeContainData;
